export enum SymbolCategoriesEnum {
	skinNails = 'skinNails',
	malPositions = 'malPositions',
	generalCharacters = 'generalCharacters'
}

export const SymbolCategoriesEnumTranslation = {
	skinNails: ['Skin & Nails', 'Hud og negle'],
	malPositions: ['Misalignments', 'Fejlstillinger'],
	generalCharacters: ['General characters', 'Generelt']
};
